import React from 'react';
import { ReactComponent as Matched } from '../../assets/images/icons/matched.svg';

export default function MatchedIcon(props) {
  return (
    <Matched className={`icon ${props.className}`} />
  );
}
